import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
export type Maybe<T> = T | null;
export type InputMaybe<T> = Maybe<T>;
export type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
export type MakeOptional<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]?: Maybe<T[SubKey]> };
export type MakeMaybe<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]: Maybe<T[SubKey]> };
const defaultOptions = {} as const;
/** All built-in and custom scalars, mapped to their actual values */
export type Scalars = {
  ID: string;
  String: string;
  Boolean: boolean;
  Int: number;
  Float: number;
};

/** A translation job currently in progress (non-terminal status). */
export type ActiveTranslationJob = {
  __typename?: 'ActiveTranslationJob';
  /** TRANSCOM client identity that owns the source (e.g. LangHub, Transcom, Panther). */
  clientId: Scalars['String'];
  /** Epoch seconds when translations are expected by — SLA deadline (stringified Long). */
  dueDate: Scalars['String'];
  /** Namespace this job belongs to. */
  namespaceId: Scalars['String'];
  /** Epoch seconds when this job was sent for translation (stringified Long). */
  sentForTranslationDate: Scalars['String'];
  /** String group being translated. */
  stringGroupId: Scalars['String'];
  /** Version of the string group submitted for translation. */
  stringGroupVersion: Scalars['String'];
  /** Tracking identifier for this active job. */
  trackingId: Scalars['String'];
  /** Translation lifecycle status (reuses TranslationStatus from searchTypes). */
  translationStatus: TranslationStatus;
};

/** Paginated list of active translation jobs. */
export type ActiveTranslationJobsConnection = {
  __typename?: 'ActiveTranslationJobsConnection';
  /** Non-null but may be empty ([]) for namespaces with no active jobs. */
  items: Array<ActiveTranslationJob>;
  nextToken?: Maybe<Scalars['String']>;
};

export type AllLocalesResponse = {
  __typename?: 'AllLocalesResponse';
  locales: Array<Scalars['String']>;
};

export type CxFamiliesList = {
  __typename?: 'CxFamiliesList';
  cxFamilies: Array<CxFamilySummary>;
  nextToken?: Maybe<Scalars['String']>;
};

export type CxFamilyDetail = {
  __typename?: 'CxFamilyDetail';
  cxFamilyId: Scalars['String'];
  cxIds: Array<CxIdDetail>;
  sourceLocales: Array<Scalars['String']>;
};

export type CxFamilyDetailResponse = {
  __typename?: 'CxFamilyDetailResponse';
  cxFamily: CxFamilyDetail;
};

export type CxFamilySummary = {
  __typename?: 'CxFamilySummary';
  cxFamilyId: Scalars['String'];
  cxIds: Array<Scalars['String']>;
};

export type CxIdDetail = {
  __typename?: 'CxIdDetail';
  cxId: Scalars['String'];
  sourceLocales: Array<Scalars['String']>;
};

/** A historical (completed/cancelled/failed) translation job. */
export type HistoricalTranslationJob = {
  __typename?: 'HistoricalTranslationJob';
  /** TRANSCOM client identity that owns the source. */
  clientId: Scalars['String'];
  /** Epoch seconds when translations were delivered (stringified Long). Null for cancelled/failed jobs. */
  deliveredOnDate?: Maybe<Scalars['String']>;
  /** Namespace this job belongs to. */
  namespaceId: Scalars['String'];
  /** Epoch seconds when this job was sent for translation (stringified Long). */
  sentForTranslationDate: Scalars['String'];
  /** String group that was translated. */
  stringGroupId: Scalars['String'];
  /** Version of the string group. */
  stringGroupVersion: Scalars['String'];
  /** Tracking identifier for this historical job. */
  trackingId: Scalars['String'];
  /** Translation lifecycle status (terminal: COMPLETE, CANCELLED, FAILED). */
  translationStatus: TranslationStatus;
};

/** Paginated list of historical translation jobs. */
export type HistoricalTranslationJobsConnection = {
  __typename?: 'HistoricalTranslationJobsConnection';
  /** Non-null but may be empty ([]) for namespaces with no historical jobs. */
  items: Array<HistoricalTranslationJob>;
  nextToken?: Maybe<Scalars['String']>;
};

export enum LocaleType {
  Source = 'SOURCE',
  Target = 'TARGET'
}

export type Namespace = {
  __typename?: 'Namespace';
  bindleResourceId: Scalars['String'];
  createdAt: Scalars['Float'];
  createdBy: Scalars['String'];
  defaultCxFamily?: Maybe<Scalars['String']>;
  namespaceId: Scalars['String'];
};

export type NamespaceDetail = {
  __typename?: 'NamespaceDetail';
  namespace: Namespace;
};

export type NamespaceItem = {
  __typename?: 'NamespaceItem';
  namespaceId: Scalars['String'];
};

export type NamespaceList = {
  __typename?: 'NamespaceList';
  namespaces: Array<NamespaceItem>;
  nextToken?: Maybe<Scalars['String']>;
};

export type Query = {
  __typename?: 'Query';
  describeCxFamily: CxFamilyDetailResponse;
  describeNamespace: NamespaceDetail;
  describeString: StringDetail;
  getUserProfile: User;
  /** List translation jobs currently in progress for a given namespace. */
  listActiveTranslationJobs: ActiveTranslationJobsConnection;
  listAllLocales: AllLocalesResponse;
  listCxFamilies: CxFamiliesList;
  listNamespaces: NamespaceList;
  listStringGroups: StringGroupsList;
  /** List historical (completed/cancelled/failed) translation jobs. */
  listTranslationJobHistory: HistoricalTranslationJobsConnection;
  searchSourceStrings: SourceStringSearchResults;
  searchTranslations: TranslationSearchResults;
};


export type QueryDescribeCxFamilyArgs = {
  cxFamilyId: Scalars['String'];
};


export type QueryDescribeNamespaceArgs = {
  namespaceId: Scalars['String'];
};


export type QueryDescribeStringArgs = {
  cxId?: InputMaybe<Scalars['String']>;
  namespaceId: Scalars['String'];
  stringGroupId: Scalars['String'];
  stringGroupVersion?: InputMaybe<Scalars['String']>;
  stringId: Scalars['String'];
};


export type QueryListActiveTranslationJobsArgs = {
  dateFrom?: InputMaybe<Scalars['String']>;
  dateTo?: InputMaybe<Scalars['String']>;
  namespaceId: Scalars['String'];
  nextToken?: InputMaybe<Scalars['String']>;
  pageSize?: InputMaybe<Scalars['Int']>;
  stringGroupId?: InputMaybe<Scalars['String']>;
};


export type QueryListAllLocalesArgs = {
  localeType: LocaleType;
};


export type QueryListCxFamiliesArgs = {
  nextToken?: InputMaybe<Scalars['String']>;
  pageSize?: InputMaybe<Scalars['Int']>;
};


export type QueryListNamespacesArgs = {
  namespaceIdPrefix?: InputMaybe<Scalars['String']>;
  nextToken?: InputMaybe<Scalars['String']>;
  pageSize?: InputMaybe<Scalars['Int']>;
  sortOrder?: InputMaybe<Scalars['String']>;
};


export type QueryListStringGroupsArgs = {
  includeLatestSnapshot?: InputMaybe<Scalars['Boolean']>;
  namespaceId: Scalars['String'];
  nextToken?: InputMaybe<Scalars['String']>;
  pageSize?: InputMaybe<Scalars['Int']>;
  stringGroupIdPrefix?: InputMaybe<Scalars['String']>;
};


export type QueryListTranslationJobHistoryArgs = {
  dateFrom?: InputMaybe<Scalars['String']>;
  dateTo?: InputMaybe<Scalars['String']>;
  namespaceId: Scalars['String'];
  nextToken?: InputMaybe<Scalars['String']>;
  pageSize?: InputMaybe<Scalars['Int']>;
  stringGroupId?: InputMaybe<Scalars['String']>;
};


export type QuerySearchSourceStringsArgs = {
  input: SearchSourceStringsInput;
};


export type QuerySearchTranslationsArgs = {
  input: SearchTranslationsInput;
};

export type SearchFilters = {
  cxFamilies?: InputMaybe<Array<Scalars['String']>>;
  cxIds?: InputMaybe<Array<Scalars['String']>>;
  namespaceIds?: InputMaybe<Array<Scalars['String']>>;
  statuses?: InputMaybe<Array<TranslationStatus>>;
  stringGroupIds?: InputMaybe<Array<Scalars['String']>>;
  translatedLocales?: InputMaybe<Array<Scalars['String']>>;
};

export type SearchSourceStringsInput = {
  exactMatch?: InputMaybe<Scalars['Boolean']>;
  filters?: InputMaybe<SearchFilters>;
  nextToken?: InputMaybe<Scalars['String']>;
  pageSize?: InputMaybe<Scalars['Int']>;
  queryText?: InputMaybe<Scalars['String']>;
  sortBy?: InputMaybe<SortBy>;
  sortOrder?: InputMaybe<SortOrder>;
};

export type SearchTranslationsInput = {
  exactMatch?: InputMaybe<Scalars['Boolean']>;
  filters?: InputMaybe<SearchFilters>;
  nextToken?: InputMaybe<Scalars['String']>;
  pageSize?: InputMaybe<Scalars['Int']>;
  queryText?: InputMaybe<Scalars['String']>;
  sortBy?: InputMaybe<SortBy>;
  sortOrder?: InputMaybe<SortOrder>;
};

export enum SearchType {
  Source = 'SOURCE',
  Translation = 'TRANSLATION'
}

export enum SortBy {
  Created = 'CREATED',
  LastUpdated = 'LAST_UPDATED',
  Namespace = 'NAMESPACE',
  Status = 'STATUS',
  StringGroupId = 'STRING_GROUP_ID',
  StringId = 'STRING_ID'
}

export enum SortOrder {
  Asc = 'ASC',
  Desc = 'DESC'
}

export type SourceStringResult = {
  __typename?: 'SourceStringResult';
  groupVersion: Scalars['String'];
  namespaceId: Scalars['String'];
  sourceContent: Scalars['String'];
  status: TranslationStatus;
  stringGroupId: Scalars['String'];
  stringId: Scalars['String'];
  variant?: Maybe<Scalars['String']>;
};

export type SourceStringSearchResults = {
  __typename?: 'SourceStringSearchResults';
  items: Array<SourceStringResult>;
  nextToken?: Maybe<Scalars['String']>;
  totalCount: Scalars['Int'];
};

export type StringDetail = {
  __typename?: 'StringDetail';
  contextNote?: Maybe<Scalars['String']>;
  cxFamilyId: Scalars['String'];
  cxIds: Array<Scalars['String']>;
  resolvedCxId?: Maybe<Scalars['String']>;
  sourceLocale: Scalars['String'];
  sourceText: Scalars['String'];
  stringGroupVersion: Scalars['String'];
  stringId: Scalars['String'];
  translationProgress: TranslationProgress;
  /**
   * Translations for this string. Scoped to the requested cxId and/or
   * stringGroupVersion when those filters are passed. Non-null — mirrors the
   * @required translations member in the DescribeStringResponse Smithy contract.
   */
  translations: Array<Translation>;
  updatedAt?: Maybe<Scalars['Float']>;
  updatedBy?: Maybe<Scalars['String']>;
  variants?: Maybe<Array<StringVariant>>;
};

export type StringGroupItem = {
  __typename?: 'StringGroupItem';
  clientId?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['Float']>;
  createdBy?: Maybe<Scalars['String']>;
  latestVersion?: Maybe<StringGroupVersionMetadata>;
  stringGroupId: Scalars['String'];
  teamName?: Maybe<Scalars['String']>;
};

export type StringGroupVersionMetadata = {
  __typename?: 'StringGroupVersionMetadata';
  cxFamilyId: Scalars['String'];
  cxIds: Array<Scalars['String']>;
  sourceLocale?: Maybe<Scalars['String']>;
  stringCount: Scalars['Int'];
  updatedAt?: Maybe<Scalars['Float']>;
  updatedBy?: Maybe<Scalars['String']>;
};

export type StringGroupsList = {
  __typename?: 'StringGroupsList';
  nextToken?: Maybe<Scalars['String']>;
  stringGroups: Array<StringGroupItem>;
};

export type StringVariant = {
  __typename?: 'StringVariant';
  contextNote?: Maybe<Scalars['String']>;
  cxId: Scalars['String'];
  sourceText: Scalars['String'];
};

export type Translation = {
  __typename?: 'Translation';
  locale: Scalars['String'];
  status: Scalars['String'];
  translatedText: Scalars['String'];
};

export type TranslationProgress = {
  __typename?: 'TranslationProgress';
  completedLocales: Array<Scalars['String']>;
  failedLocales: Array<Scalars['String']>;
  inProgressLocales: Array<Scalars['String']>;
};

export type TranslationResult = {
  __typename?: 'TranslationResult';
  groupVersion: Scalars['String'];
  /**
   * Target locale of this translation, in hyphenated BCP-47 form (e.g. `de-DE`,
   * `es-ES`). TRANSCOM is the upstream source of this value and emits hyphens
   * (`TargetString.getLocale()` documents `"es-ES"`);
   * `TranscomResponseMapper.toTargetString` passes it through unnormalized and the
   * OpenSearch `locale` mapping is `keyword`, so the index stores it verbatim —
   * real-table integration tests use `de-DE` / `fr-FR`. Mirrors the
   * `@required locale` member on the Smithy `TranslationSearchResult`;
   * source-string results have no equivalent.
   */
  locale: Scalars['String'];
  localizedText: Scalars['String'];
  namespaceId: Scalars['String'];
  stringGroupId: Scalars['String'];
  stringId: Scalars['String'];
  variant?: Maybe<Scalars['String']>;
};

export type TranslationSearchResults = {
  __typename?: 'TranslationSearchResults';
  items: Array<TranslationResult>;
  nextToken?: Maybe<Scalars['String']>;
  totalCount: Scalars['Int'];
};

/** Translation lifecycle status of a string group version. */
export enum TranslationStatus {
  /** Translation was cancelled. */
  Cancelled = 'CANCELLED',
  /** Translation is complete for all target locales. */
  Complete = 'COMPLETE',
  /** Translation failed for one or more locales. */
  Failed = 'FAILED',
  /** Translation work is in progress. */
  InProgress = 'IN_PROGRESS'
}

export type User = {
  __typename?: 'User';
  username: Scalars['String'];
};

export type DescribeCxFamilyQueryVariables = Exact<{
  cxFamilyId: Scalars['String'];
}>;


export type DescribeCxFamilyQuery = { __typename?: 'Query', describeCxFamily: { __typename?: 'CxFamilyDetailResponse', cxFamily: { __typename?: 'CxFamilyDetail', cxFamilyId: string, sourceLocales: Array<string>, cxIds: Array<{ __typename?: 'CxIdDetail', cxId: string, sourceLocales: Array<string> }> } } };

export type DescribeNamespaceQueryVariables = Exact<{
  namespaceId: Scalars['String'];
}>;


export type DescribeNamespaceQuery = { __typename?: 'Query', describeNamespace: { __typename?: 'NamespaceDetail', namespace: { __typename?: 'Namespace', namespaceId: string, bindleResourceId: string, defaultCxFamily?: string | null, createdAt: number, createdBy: string } } };

export type DescribeStringQueryVariables = Exact<{
  namespaceId: Scalars['String'];
  stringGroupId: Scalars['String'];
  stringId: Scalars['String'];
  cxId?: InputMaybe<Scalars['String']>;
  stringGroupVersion?: InputMaybe<Scalars['String']>;
}>;


export type DescribeStringQuery = { __typename?: 'Query', describeString: { __typename?: 'StringDetail', stringId: string, sourceLocale: string, sourceText: string, contextNote?: string | null, resolvedCxId?: string | null, stringGroupVersion: string, cxFamilyId: string, cxIds: Array<string>, updatedAt?: number | null, updatedBy?: string | null, variants?: Array<{ __typename?: 'StringVariant', cxId: string, sourceText: string, contextNote?: string | null }> | null, translationProgress: { __typename?: 'TranslationProgress', completedLocales: Array<string>, inProgressLocales: Array<string>, failedLocales: Array<string> }, translations: Array<{ __typename?: 'Translation', locale: string, translatedText: string, status: string }> } };

export type GetUserProfileQueryVariables = Exact<{ [key: string]: never; }>;


export type GetUserProfileQuery = { __typename?: 'Query', getUserProfile: { __typename?: 'User', username: string } };

export type ListActiveTranslationJobsQueryVariables = Exact<{
  namespaceId: Scalars['String'];
  stringGroupId?: InputMaybe<Scalars['String']>;
  dateFrom?: InputMaybe<Scalars['String']>;
  dateTo?: InputMaybe<Scalars['String']>;
  pageSize?: InputMaybe<Scalars['Int']>;
  nextToken?: InputMaybe<Scalars['String']>;
}>;


export type ListActiveTranslationJobsQuery = { __typename?: 'Query', listActiveTranslationJobs: { __typename?: 'ActiveTranslationJobsConnection', nextToken?: string | null, items: Array<{ __typename?: 'ActiveTranslationJob', namespaceId: string, stringGroupId: string, stringGroupVersion: string, trackingId: string, clientId: string, translationStatus: TranslationStatus, sentForTranslationDate: string, dueDate: string }> } };

export type ListAllLocalesQueryVariables = Exact<{
  localeType: LocaleType;
}>;


export type ListAllLocalesQuery = { __typename?: 'Query', listAllLocales: { __typename?: 'AllLocalesResponse', locales: Array<string> } };

export type ListCxFamiliesQueryVariables = Exact<{
  pageSize?: InputMaybe<Scalars['Int']>;
  nextToken?: InputMaybe<Scalars['String']>;
}>;


export type ListCxFamiliesQuery = { __typename?: 'Query', listCxFamilies: { __typename?: 'CxFamiliesList', nextToken?: string | null, cxFamilies: Array<{ __typename?: 'CxFamilySummary', cxFamilyId: string, cxIds: Array<string> }> } };

export type ListNamespacesQueryVariables = Exact<{
  namespaceIdPrefix?: InputMaybe<Scalars['String']>;
  pageSize?: InputMaybe<Scalars['Int']>;
  nextToken?: InputMaybe<Scalars['String']>;
  sortOrder?: InputMaybe<Scalars['String']>;
}>;


export type ListNamespacesQuery = { __typename?: 'Query', listNamespaces: { __typename?: 'NamespaceList', nextToken?: string | null, namespaces: Array<{ __typename?: 'NamespaceItem', namespaceId: string }> } };

export type ListStringGroupsQueryVariables = Exact<{
  namespaceId: Scalars['String'];
  stringGroupIdPrefix?: InputMaybe<Scalars['String']>;
  pageSize?: InputMaybe<Scalars['Int']>;
  nextToken?: InputMaybe<Scalars['String']>;
  includeLatestSnapshot?: InputMaybe<Scalars['Boolean']>;
}>;


export type ListStringGroupsQuery = { __typename?: 'Query', listStringGroups: { __typename?: 'StringGroupsList', nextToken?: string | null, stringGroups: Array<{ __typename?: 'StringGroupItem', stringGroupId: string, clientId?: string | null, createdBy?: string | null, createdAt?: number | null, teamName?: string | null, latestVersion?: { __typename?: 'StringGroupVersionMetadata', cxFamilyId: string, cxIds: Array<string>, sourceLocale?: string | null, stringCount: number, updatedAt?: number | null, updatedBy?: string | null } | null }> } };

export type ListTranslationJobHistoryQueryVariables = Exact<{
  namespaceId: Scalars['String'];
  stringGroupId?: InputMaybe<Scalars['String']>;
  dateFrom?: InputMaybe<Scalars['String']>;
  dateTo?: InputMaybe<Scalars['String']>;
  pageSize?: InputMaybe<Scalars['Int']>;
  nextToken?: InputMaybe<Scalars['String']>;
}>;


export type ListTranslationJobHistoryQuery = { __typename?: 'Query', listTranslationJobHistory: { __typename?: 'HistoricalTranslationJobsConnection', nextToken?: string | null, items: Array<{ __typename?: 'HistoricalTranslationJob', namespaceId: string, stringGroupId: string, stringGroupVersion: string, trackingId: string, clientId: string, translationStatus: TranslationStatus, sentForTranslationDate: string, deliveredOnDate?: string | null }> } };

export type SearchSourceStringsQueryVariables = Exact<{
  input: SearchSourceStringsInput;
}>;


export type SearchSourceStringsQuery = { __typename?: 'Query', searchSourceStrings: { __typename?: 'SourceStringSearchResults', nextToken?: string | null, totalCount: number, items: Array<{ __typename?: 'SourceStringResult', stringId: string, namespaceId: string, stringGroupId: string, groupVersion: string, variant?: string | null, status: TranslationStatus, sourceContent: string }> } };

export type SearchTranslationsQueryVariables = Exact<{
  input: SearchTranslationsInput;
}>;


export type SearchTranslationsQuery = { __typename?: 'Query', searchTranslations: { __typename?: 'TranslationSearchResults', nextToken?: string | null, totalCount: number, items: Array<{ __typename?: 'TranslationResult', stringId: string, namespaceId: string, stringGroupId: string, groupVersion: string, variant?: string | null, localizedText: string, locale: string }> } };


export const DescribeCxFamilyDocument = gql`
    query DescribeCxFamily($cxFamilyId: String!) {
  describeCxFamily(cxFamilyId: $cxFamilyId) {
    cxFamily {
      cxFamilyId
      cxIds {
        cxId
        sourceLocales
      }
      sourceLocales
    }
  }
}
    `;

/**
 * __useDescribeCxFamilyQuery__
 *
 * To run a query within a React component, call `useDescribeCxFamilyQuery` and pass it any options that fit your needs.
 * When your component renders, `useDescribeCxFamilyQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useDescribeCxFamilyQuery({
 *   variables: {
 *      cxFamilyId: // value for 'cxFamilyId'
 *   },
 * });
 */
export function useDescribeCxFamilyQuery(baseOptions: Apollo.QueryHookOptions<DescribeCxFamilyQuery, DescribeCxFamilyQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<DescribeCxFamilyQuery, DescribeCxFamilyQueryVariables>(DescribeCxFamilyDocument, options);
      }
export function useDescribeCxFamilyLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<DescribeCxFamilyQuery, DescribeCxFamilyQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<DescribeCxFamilyQuery, DescribeCxFamilyQueryVariables>(DescribeCxFamilyDocument, options);
        }
export type DescribeCxFamilyQueryHookResult = ReturnType<typeof useDescribeCxFamilyQuery>;
export type DescribeCxFamilyLazyQueryHookResult = ReturnType<typeof useDescribeCxFamilyLazyQuery>;
export type DescribeCxFamilyQueryResult = Apollo.QueryResult<DescribeCxFamilyQuery, DescribeCxFamilyQueryVariables>;
export const DescribeNamespaceDocument = gql`
    query DescribeNamespace($namespaceId: String!) {
  describeNamespace(namespaceId: $namespaceId) {
    namespace {
      namespaceId
      bindleResourceId
      defaultCxFamily
      createdAt
      createdBy
    }
  }
}
    `;

/**
 * __useDescribeNamespaceQuery__
 *
 * To run a query within a React component, call `useDescribeNamespaceQuery` and pass it any options that fit your needs.
 * When your component renders, `useDescribeNamespaceQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useDescribeNamespaceQuery({
 *   variables: {
 *      namespaceId: // value for 'namespaceId'
 *   },
 * });
 */
export function useDescribeNamespaceQuery(baseOptions: Apollo.QueryHookOptions<DescribeNamespaceQuery, DescribeNamespaceQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<DescribeNamespaceQuery, DescribeNamespaceQueryVariables>(DescribeNamespaceDocument, options);
      }
export function useDescribeNamespaceLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<DescribeNamespaceQuery, DescribeNamespaceQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<DescribeNamespaceQuery, DescribeNamespaceQueryVariables>(DescribeNamespaceDocument, options);
        }
export type DescribeNamespaceQueryHookResult = ReturnType<typeof useDescribeNamespaceQuery>;
export type DescribeNamespaceLazyQueryHookResult = ReturnType<typeof useDescribeNamespaceLazyQuery>;
export type DescribeNamespaceQueryResult = Apollo.QueryResult<DescribeNamespaceQuery, DescribeNamespaceQueryVariables>;
export const DescribeStringDocument = gql`
    query DescribeString($namespaceId: String!, $stringGroupId: String!, $stringId: String!, $cxId: String, $stringGroupVersion: String) {
  describeString(
    namespaceId: $namespaceId
    stringGroupId: $stringGroupId
    stringId: $stringId
    cxId: $cxId
    stringGroupVersion: $stringGroupVersion
  ) {
    stringId
    sourceLocale
    sourceText
    contextNote
    variants {
      cxId
      sourceText
      contextNote
    }
    resolvedCxId
    stringGroupVersion
    cxFamilyId
    cxIds
    translationProgress {
      completedLocales
      inProgressLocales
      failedLocales
    }
    translations {
      locale
      translatedText
      status
    }
    updatedAt
    updatedBy
  }
}
    `;

/**
 * __useDescribeStringQuery__
 *
 * To run a query within a React component, call `useDescribeStringQuery` and pass it any options that fit your needs.
 * When your component renders, `useDescribeStringQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useDescribeStringQuery({
 *   variables: {
 *      namespaceId: // value for 'namespaceId'
 *      stringGroupId: // value for 'stringGroupId'
 *      stringId: // value for 'stringId'
 *      cxId: // value for 'cxId'
 *      stringGroupVersion: // value for 'stringGroupVersion'
 *   },
 * });
 */
export function useDescribeStringQuery(baseOptions: Apollo.QueryHookOptions<DescribeStringQuery, DescribeStringQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<DescribeStringQuery, DescribeStringQueryVariables>(DescribeStringDocument, options);
      }
export function useDescribeStringLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<DescribeStringQuery, DescribeStringQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<DescribeStringQuery, DescribeStringQueryVariables>(DescribeStringDocument, options);
        }
export type DescribeStringQueryHookResult = ReturnType<typeof useDescribeStringQuery>;
export type DescribeStringLazyQueryHookResult = ReturnType<typeof useDescribeStringLazyQuery>;
export type DescribeStringQueryResult = Apollo.QueryResult<DescribeStringQuery, DescribeStringQueryVariables>;
export const GetUserProfileDocument = gql`
    query GetUserProfile {
  getUserProfile {
    username
  }
}
    `;

/**
 * __useGetUserProfileQuery__
 *
 * To run a query within a React component, call `useGetUserProfileQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetUserProfileQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetUserProfileQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetUserProfileQuery(baseOptions?: Apollo.QueryHookOptions<GetUserProfileQuery, GetUserProfileQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetUserProfileQuery, GetUserProfileQueryVariables>(GetUserProfileDocument, options);
      }
export function useGetUserProfileLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetUserProfileQuery, GetUserProfileQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetUserProfileQuery, GetUserProfileQueryVariables>(GetUserProfileDocument, options);
        }
export type GetUserProfileQueryHookResult = ReturnType<typeof useGetUserProfileQuery>;
export type GetUserProfileLazyQueryHookResult = ReturnType<typeof useGetUserProfileLazyQuery>;
export type GetUserProfileQueryResult = Apollo.QueryResult<GetUserProfileQuery, GetUserProfileQueryVariables>;
export const ListActiveTranslationJobsDocument = gql`
    query ListActiveTranslationJobs($namespaceId: String!, $stringGroupId: String, $dateFrom: String, $dateTo: String, $pageSize: Int, $nextToken: String) {
  listActiveTranslationJobs(
    namespaceId: $namespaceId
    stringGroupId: $stringGroupId
    dateFrom: $dateFrom
    dateTo: $dateTo
    pageSize: $pageSize
    nextToken: $nextToken
  ) {
    items {
      namespaceId
      stringGroupId
      stringGroupVersion
      trackingId
      clientId
      translationStatus
      sentForTranslationDate
      dueDate
    }
    nextToken
  }
}
    `;

/**
 * __useListActiveTranslationJobsQuery__
 *
 * To run a query within a React component, call `useListActiveTranslationJobsQuery` and pass it any options that fit your needs.
 * When your component renders, `useListActiveTranslationJobsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useListActiveTranslationJobsQuery({
 *   variables: {
 *      namespaceId: // value for 'namespaceId'
 *      stringGroupId: // value for 'stringGroupId'
 *      dateFrom: // value for 'dateFrom'
 *      dateTo: // value for 'dateTo'
 *      pageSize: // value for 'pageSize'
 *      nextToken: // value for 'nextToken'
 *   },
 * });
 */
export function useListActiveTranslationJobsQuery(baseOptions: Apollo.QueryHookOptions<ListActiveTranslationJobsQuery, ListActiveTranslationJobsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ListActiveTranslationJobsQuery, ListActiveTranslationJobsQueryVariables>(ListActiveTranslationJobsDocument, options);
      }
export function useListActiveTranslationJobsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ListActiveTranslationJobsQuery, ListActiveTranslationJobsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ListActiveTranslationJobsQuery, ListActiveTranslationJobsQueryVariables>(ListActiveTranslationJobsDocument, options);
        }
export type ListActiveTranslationJobsQueryHookResult = ReturnType<typeof useListActiveTranslationJobsQuery>;
export type ListActiveTranslationJobsLazyQueryHookResult = ReturnType<typeof useListActiveTranslationJobsLazyQuery>;
export type ListActiveTranslationJobsQueryResult = Apollo.QueryResult<ListActiveTranslationJobsQuery, ListActiveTranslationJobsQueryVariables>;
export const ListAllLocalesDocument = gql`
    query ListAllLocales($localeType: LocaleType!) {
  listAllLocales(localeType: $localeType) {
    locales
  }
}
    `;

/**
 * __useListAllLocalesQuery__
 *
 * To run a query within a React component, call `useListAllLocalesQuery` and pass it any options that fit your needs.
 * When your component renders, `useListAllLocalesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useListAllLocalesQuery({
 *   variables: {
 *      localeType: // value for 'localeType'
 *   },
 * });
 */
export function useListAllLocalesQuery(baseOptions: Apollo.QueryHookOptions<ListAllLocalesQuery, ListAllLocalesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ListAllLocalesQuery, ListAllLocalesQueryVariables>(ListAllLocalesDocument, options);
      }
export function useListAllLocalesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ListAllLocalesQuery, ListAllLocalesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ListAllLocalesQuery, ListAllLocalesQueryVariables>(ListAllLocalesDocument, options);
        }
export type ListAllLocalesQueryHookResult = ReturnType<typeof useListAllLocalesQuery>;
export type ListAllLocalesLazyQueryHookResult = ReturnType<typeof useListAllLocalesLazyQuery>;
export type ListAllLocalesQueryResult = Apollo.QueryResult<ListAllLocalesQuery, ListAllLocalesQueryVariables>;
export const ListCxFamiliesDocument = gql`
    query ListCxFamilies($pageSize: Int, $nextToken: String) {
  listCxFamilies(pageSize: $pageSize, nextToken: $nextToken) {
    cxFamilies {
      cxFamilyId
      cxIds
    }
    nextToken
  }
}
    `;

/**
 * __useListCxFamiliesQuery__
 *
 * To run a query within a React component, call `useListCxFamiliesQuery` and pass it any options that fit your needs.
 * When your component renders, `useListCxFamiliesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useListCxFamiliesQuery({
 *   variables: {
 *      pageSize: // value for 'pageSize'
 *      nextToken: // value for 'nextToken'
 *   },
 * });
 */
export function useListCxFamiliesQuery(baseOptions?: Apollo.QueryHookOptions<ListCxFamiliesQuery, ListCxFamiliesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ListCxFamiliesQuery, ListCxFamiliesQueryVariables>(ListCxFamiliesDocument, options);
      }
export function useListCxFamiliesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ListCxFamiliesQuery, ListCxFamiliesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ListCxFamiliesQuery, ListCxFamiliesQueryVariables>(ListCxFamiliesDocument, options);
        }
export type ListCxFamiliesQueryHookResult = ReturnType<typeof useListCxFamiliesQuery>;
export type ListCxFamiliesLazyQueryHookResult = ReturnType<typeof useListCxFamiliesLazyQuery>;
export type ListCxFamiliesQueryResult = Apollo.QueryResult<ListCxFamiliesQuery, ListCxFamiliesQueryVariables>;
export const ListNamespacesDocument = gql`
    query ListNamespaces($namespaceIdPrefix: String, $pageSize: Int, $nextToken: String, $sortOrder: String) {
  listNamespaces(
    namespaceIdPrefix: $namespaceIdPrefix
    pageSize: $pageSize
    nextToken: $nextToken
    sortOrder: $sortOrder
  ) {
    namespaces {
      namespaceId
    }
    nextToken
  }
}
    `;

/**
 * __useListNamespacesQuery__
 *
 * To run a query within a React component, call `useListNamespacesQuery` and pass it any options that fit your needs.
 * When your component renders, `useListNamespacesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useListNamespacesQuery({
 *   variables: {
 *      namespaceIdPrefix: // value for 'namespaceIdPrefix'
 *      pageSize: // value for 'pageSize'
 *      nextToken: // value for 'nextToken'
 *      sortOrder: // value for 'sortOrder'
 *   },
 * });
 */
export function useListNamespacesQuery(baseOptions?: Apollo.QueryHookOptions<ListNamespacesQuery, ListNamespacesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ListNamespacesQuery, ListNamespacesQueryVariables>(ListNamespacesDocument, options);
      }
export function useListNamespacesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ListNamespacesQuery, ListNamespacesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ListNamespacesQuery, ListNamespacesQueryVariables>(ListNamespacesDocument, options);
        }
export type ListNamespacesQueryHookResult = ReturnType<typeof useListNamespacesQuery>;
export type ListNamespacesLazyQueryHookResult = ReturnType<typeof useListNamespacesLazyQuery>;
export type ListNamespacesQueryResult = Apollo.QueryResult<ListNamespacesQuery, ListNamespacesQueryVariables>;
export const ListStringGroupsDocument = gql`
    query ListStringGroups($namespaceId: String!, $stringGroupIdPrefix: String, $pageSize: Int, $nextToken: String, $includeLatestSnapshot: Boolean) {
  listStringGroups(
    namespaceId: $namespaceId
    stringGroupIdPrefix: $stringGroupIdPrefix
    pageSize: $pageSize
    nextToken: $nextToken
    includeLatestSnapshot: $includeLatestSnapshot
  ) {
    stringGroups {
      stringGroupId
      clientId
      createdBy
      createdAt
      teamName
      latestVersion {
        cxFamilyId
        cxIds
        sourceLocale
        stringCount
        updatedAt
        updatedBy
      }
    }
    nextToken
  }
}
    `;

/**
 * __useListStringGroupsQuery__
 *
 * To run a query within a React component, call `useListStringGroupsQuery` and pass it any options that fit your needs.
 * When your component renders, `useListStringGroupsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useListStringGroupsQuery({
 *   variables: {
 *      namespaceId: // value for 'namespaceId'
 *      stringGroupIdPrefix: // value for 'stringGroupIdPrefix'
 *      pageSize: // value for 'pageSize'
 *      nextToken: // value for 'nextToken'
 *      includeLatestSnapshot: // value for 'includeLatestSnapshot'
 *   },
 * });
 */
export function useListStringGroupsQuery(baseOptions: Apollo.QueryHookOptions<ListStringGroupsQuery, ListStringGroupsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ListStringGroupsQuery, ListStringGroupsQueryVariables>(ListStringGroupsDocument, options);
      }
export function useListStringGroupsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ListStringGroupsQuery, ListStringGroupsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ListStringGroupsQuery, ListStringGroupsQueryVariables>(ListStringGroupsDocument, options);
        }
export type ListStringGroupsQueryHookResult = ReturnType<typeof useListStringGroupsQuery>;
export type ListStringGroupsLazyQueryHookResult = ReturnType<typeof useListStringGroupsLazyQuery>;
export type ListStringGroupsQueryResult = Apollo.QueryResult<ListStringGroupsQuery, ListStringGroupsQueryVariables>;
export const ListTranslationJobHistoryDocument = gql`
    query ListTranslationJobHistory($namespaceId: String!, $stringGroupId: String, $dateFrom: String, $dateTo: String, $pageSize: Int, $nextToken: String) {
  listTranslationJobHistory(
    namespaceId: $namespaceId
    stringGroupId: $stringGroupId
    dateFrom: $dateFrom
    dateTo: $dateTo
    pageSize: $pageSize
    nextToken: $nextToken
  ) {
    items {
      namespaceId
      stringGroupId
      stringGroupVersion
      trackingId
      clientId
      translationStatus
      sentForTranslationDate
      deliveredOnDate
    }
    nextToken
  }
}
    `;

/**
 * __useListTranslationJobHistoryQuery__
 *
 * To run a query within a React component, call `useListTranslationJobHistoryQuery` and pass it any options that fit your needs.
 * When your component renders, `useListTranslationJobHistoryQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useListTranslationJobHistoryQuery({
 *   variables: {
 *      namespaceId: // value for 'namespaceId'
 *      stringGroupId: // value for 'stringGroupId'
 *      dateFrom: // value for 'dateFrom'
 *      dateTo: // value for 'dateTo'
 *      pageSize: // value for 'pageSize'
 *      nextToken: // value for 'nextToken'
 *   },
 * });
 */
export function useListTranslationJobHistoryQuery(baseOptions: Apollo.QueryHookOptions<ListTranslationJobHistoryQuery, ListTranslationJobHistoryQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ListTranslationJobHistoryQuery, ListTranslationJobHistoryQueryVariables>(ListTranslationJobHistoryDocument, options);
      }
export function useListTranslationJobHistoryLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ListTranslationJobHistoryQuery, ListTranslationJobHistoryQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ListTranslationJobHistoryQuery, ListTranslationJobHistoryQueryVariables>(ListTranslationJobHistoryDocument, options);
        }
export type ListTranslationJobHistoryQueryHookResult = ReturnType<typeof useListTranslationJobHistoryQuery>;
export type ListTranslationJobHistoryLazyQueryHookResult = ReturnType<typeof useListTranslationJobHistoryLazyQuery>;
export type ListTranslationJobHistoryQueryResult = Apollo.QueryResult<ListTranslationJobHistoryQuery, ListTranslationJobHistoryQueryVariables>;
export const SearchSourceStringsDocument = gql`
    query SearchSourceStrings($input: SearchSourceStringsInput!) {
  searchSourceStrings(input: $input) {
    items {
      stringId
      namespaceId
      stringGroupId
      groupVersion
      variant
      status
      sourceContent
    }
    nextToken
    totalCount
  }
}
    `;

/**
 * __useSearchSourceStringsQuery__
 *
 * To run a query within a React component, call `useSearchSourceStringsQuery` and pass it any options that fit your needs.
 * When your component renders, `useSearchSourceStringsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSearchSourceStringsQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useSearchSourceStringsQuery(baseOptions: Apollo.QueryHookOptions<SearchSourceStringsQuery, SearchSourceStringsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<SearchSourceStringsQuery, SearchSourceStringsQueryVariables>(SearchSourceStringsDocument, options);
      }
export function useSearchSourceStringsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<SearchSourceStringsQuery, SearchSourceStringsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<SearchSourceStringsQuery, SearchSourceStringsQueryVariables>(SearchSourceStringsDocument, options);
        }
export type SearchSourceStringsQueryHookResult = ReturnType<typeof useSearchSourceStringsQuery>;
export type SearchSourceStringsLazyQueryHookResult = ReturnType<typeof useSearchSourceStringsLazyQuery>;
export type SearchSourceStringsQueryResult = Apollo.QueryResult<SearchSourceStringsQuery, SearchSourceStringsQueryVariables>;
export const SearchTranslationsDocument = gql`
    query SearchTranslations($input: SearchTranslationsInput!) {
  searchTranslations(input: $input) {
    items {
      stringId
      namespaceId
      stringGroupId
      groupVersion
      variant
      localizedText
      locale
    }
    nextToken
    totalCount
  }
}
    `;

/**
 * __useSearchTranslationsQuery__
 *
 * To run a query within a React component, call `useSearchTranslationsQuery` and pass it any options that fit your needs.
 * When your component renders, `useSearchTranslationsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSearchTranslationsQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useSearchTranslationsQuery(baseOptions: Apollo.QueryHookOptions<SearchTranslationsQuery, SearchTranslationsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<SearchTranslationsQuery, SearchTranslationsQueryVariables>(SearchTranslationsDocument, options);
      }
export function useSearchTranslationsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<SearchTranslationsQuery, SearchTranslationsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<SearchTranslationsQuery, SearchTranslationsQueryVariables>(SearchTranslationsDocument, options);
        }
export type SearchTranslationsQueryHookResult = ReturnType<typeof useSearchTranslationsQuery>;
export type SearchTranslationsLazyQueryHookResult = ReturnType<typeof useSearchTranslationsLazyQuery>;
export type SearchTranslationsQueryResult = Apollo.QueryResult<SearchTranslationsQuery, SearchTranslationsQueryVariables>;